import React from 'react';
import Card from '@/components/ui/Card';
import { Player } from '@/types';

interface PlayerSelectGridProps {
  players: Player[];
  selectedIds: string[];
  toggleSelect: (id: string) => void;
}

const PlayerSelectGrid: React.FC<PlayerSelectGridProps> = ({ players, selectedIds, toggleSelect }) => {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {players.map((p) => {
        const isSelected = selectedIds.includes(p.id);
        return (
          <Card 
            key={p.id}
            className={`cursor-pointer transition-all duration-200 ${
              isSelected 
                ? 'ring-2 ring-primary-500 dark:ring-primary-400 bg-primary-50 dark:bg-primary-950/30 border-primary-300 dark:border-primary-700' 
                : 'hover:shadow-lg hover:scale-[1.02]'
            }`}
            onClick={() => toggleSelect(p.id)}
          >
            <div className="flex items-center justify-between">
              <div>
                <div className={`font-medium ${
                  isSelected 
                    ? 'text-primary-900 dark:!text-white' 
                    : 'text-gray-900 dark:!text-white'
                }`}>
                  {p.name}
                </div>
                <div className={`text-sm ${
                  isSelected 
                    ? 'text-primary-700 dark:!text-gray-200' 
                    : 'text-gray-500 dark:!text-gray-300'
                }`}>
                  {p.position} • {p.team || 'Unassigned'}
                </div>
              </div>
              <div>
                <input 
                  type="checkbox" 
                  checked={isSelected} 
                  onChange={() => toggleSelect(p.id)} 
                  className="w-5 h-5 text-primary-600 dark:text-primary-400 bg-white dark:bg-gray-700 border-gray-300 dark:border-gray-600 rounded focus:ring-primary-500 dark:focus:ring-primary-400" 
                />
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default PlayerSelectGrid;
